"use strict";

var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.reduce.js");
require("core-js/modules/es.iterator.some.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ordersProductsDispatches = require("@/api/orders-products-dispatches");
var _index = _interopRequireDefault(require("@/components/Inr/index.vue"));
var _router = _interopRequireDefault(require("@/router"));
var _ordersDispatches = require("@/api/orders-dispatches");
var _admin = require("@/store/modules/admin");
var _common = require("@/common");
var _inventoryInwardsLogs = require("@/api/inventory-inwards-logs");
var _units = require("@/api/locations/units");
var _utils = require("@/utils");
var _products = require("@/api/products");
var _dealers = require("@/api/dealers");
var _dealersTransporters = require("@/api/dealers-transporters");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.list = [];
    this.listLoading = false;
    this.loadingForRequestApproval = false;
    this.loadingForApprove = false;
    this.loadingForReject = false;
    this.loadingForPreview = false;
    this.loggedInAdmin = null;
    this.formData = {
      id: null,
      status: '',
      tdsAmount: 0
    };
    this.rejectDialogFormVisible = false;
    this.approveDialogFormVisible = false;
    this.isReadOnlyUser = false;
    // private dispatchInfo: IOrdersDispatchData;
    this.dispatchInfo = null;
    this.showRequestApprovalButton = false;
    this.showApproveButton = false;
    this.showRejectButton = false;
    this.ordersDispatchId = 0;
    this.showPreviewButton = false;
    this.isBranchDispatch = false;
    this.dialogTitle = 'Approve Dispatch';
    this.showInTransitButton = true;
    this.isStatusInTransit = false;
    this.isTransitQuantityEqual = true;
    this.inventoryArray = [];
    this.unitId = null;
    this.sourceBranchId = null;
    this.destinationBranchId = null;
    this.sourceUnitId = null;
    this.destinationUnitId = null;
    this.ordersProductsDispatch = [];
    this.isDispatchApproved = false;
    this.wrongProductDialogVisible = false;
    this.productListLoading = false;
    this.products = [];
    this.selectedRow = null;
    this.selectedRowIndex = -1;
    this.wrongProductTableData = [];
    this.sourceBranchName = '';
    this.destinationBranchName = '';
    this.sourceUnitName = '';
    this.destinationUnitName = '';
    this.sourceAdminId = null;
    this.isTransitApprovedAlready = false;
    this.loggedInAdminId = undefined;
    this.editDialogVisible = false;
    this.editSaving = false;
    this.editForm = {
      dealersTransporterId: null,
      ewayBillNo: '',
      dealerSpecialDiscount: 0,
      tdsAmount: 0,
      tcsAmount: 0,
      softRecalculate: true
    };
    this.transporterOptions = [];
    this.rules = {
      rejectReason: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
  }
  get hasAnyWrongProduct() {
    return this.list.some(row => row.isWrongProduct === true);
  }
  activated() {
    this.isReadOnlyUser = (0, _common.isReadOnly)();
    this.loggedInAdmin = _admin.AdminModule;
    this.loggedInAdminId = _admin.AdminModule.id;
    const id = this.$route.params && this.$route.params.id;
    this.ordersDispatchId = parseInt(id);
    this.getList(this.ordersDispatchId);
  }
  deactivated() {
    // Clean up state to prevent memory leaks
    this.list = [];
    this.inventoryArray = [];
    this.products = [];
    this.dispatchInfo = null;
  }
  async getList(ordersDispatchId) {
    try {
      this.listLoading = true;
      // get products in dispatch
      const data = await (0, _ordersProductsDispatches.listOrdersProductsDispatches)(ordersDispatchId);
      for (const item of data) {
        item.isDisabled = true;
        item.maxQuantity = item.quantity;
        // Initialize productsReceived if not present
        if (!item.productsReceived) {
          item.productsReceived = [];
        }
        // Set quantityReceived to be same as quantity dispatched
        item.quantityReceived = item.quantity;
        // Initialize inventory array for each item
        this.handleQuantityReceived(item, item.quantity);
      }
      this.list = data;
      // get dispatch info
      const info = await (0, _ordersDispatches.getOrdersDispathById)(ordersDispatchId);
      if (info.status === 'Approved') {
        this.isDispatchApproved = true;
      }
      this.ordersProductsDispatch = info.ordersProductsDispatch;
      if (this.ordersProductsDispatch[0].quantityReceived) {
        this.isTransitApprovedAlready = true;
      }
      this.sourceAdminId = info.adminId;
      // get destination stock branchId
      const dealer = await (0, _dealers.getDealerById)(info.dealerId);
      // get corresponding destination unitId
      if (await (0, _common.isBranchDispatch)(info.dealerId)) {
        this.destinationBranchId = dealer.stockBranchId;
        // find out source and destination units and branches
        this.sourceUnitId = info.unitId;
        this.sourceUnitName = info.unit.name;
        // get the corresponding source branchId
        this.sourceBranchId = info.unit.branchId;
        // get the corresponding source branch name
        this.sourceBranchName = `${info.branch.name}-${info.branch.code}`;
        const unit = await (0, _units.getUnitByBranchId)(this.destinationBranchId);
        this.destinationUnitId = unit[0].id;
        this.destinationUnitName = unit[0].name;
        this.destinationBranchName = `${unit[0].branch.name}-${unit[0].branch.code}`;
      }
      if (info.status === 'In Transit') {
        this.isStatusInTransit = true;
      }
      // check if the dealer is a branch
      if (await (0, _common.isBranchDispatch)(info.dealerId)) {
        this.isBranchDispatch = true;
        this.dialogTitle = 'In Transit Dispatch';
      }
      // editing flag for terms of delivery
      if (info.status === 'Request Approval') {
        info.editingTermsOfDelivery = false;
        info.modifiedTermsOfDelivery = info.termsOfDelivery;
      }
      // editing flag for vehicle number
      info.editingVehicleNumber = false;
      info.modifiedVehicleNumber = info.vehicleNumber;
      // assign
      this.dispatchInfo = info;
      // set tds amount
      this.formData.tdsAmount = this.dispatchInfo.tdsAmount;
      // show action buttons if status is pending and logged in user is admin or invoice manager
      switch (this.dispatchInfo.status) {
        case 'Request Approval':
          this.showRequestApprovalButton = false;
          this.showPreviewButton = (0, _common.isSuperAdmin)() || (0, _common.isAdmin)() || (0, _common.isInvoiceManager)();
          this.showApproveButton = (0, _common.isSuperAdmin)() || (0, _common.isAdmin)() || (0, _common.isInvoiceManager)();
          this.showRejectButton = (0, _common.isSuperAdmin)() || (0, _common.isAdmin)() || (0, _common.isInvoiceManager)();
          break;
        case 'Approved':
          this.showRequestApprovalButton = false;
          this.showApproveButton = false;
          this.showPreviewButton = true;
          // Reject is allowed only if, for each document that was actually
          // generated (has an S3 url), it has also been cancelled.
          // If a document was never generated, it doesn't block Reject.
          this.showRejectButton = this.isDispatchEligibleForReject();
          break;
        case 'Pending':
          this.showRequestApprovalButton = (0, _common.isUnitManager)() && this.dispatchInfo.createdBy === this.loggedInAdminId;
          this.showApproveButton = false;
          this.showPreviewButton = false;
          this.showRejectButton = false;
          break;
        case 'In Transit':
          this.showRejectButton = (0, _common.isSuperAdmin)();
          break;
        default:
          this.showApproveButton = false;
          this.showRejectButton = false;
          this.showRequestApprovalButton = false;
          this.showPreviewButton = false;
          break;
      }
      // update dispatch ID for saving form
      this.formData.id = ordersDispatchId;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  // A document (e-Invoice / E-way) is considered "made" if it was generated
  // (irn / ewayBillNo is set). If made, it must also have its corresponding
  // cancel date set before the dispatch can be rejected. If not made, it
  // doesn't block Reject.
  isDispatchEligibleForReject() {
    const eInvoiceMade = !!this.dispatchInfo.irn;
    const ewayMade = !!this.dispatchInfo.ewayBillNo;
    const eInvoiceOk = eInvoiceMade ? !!this.dispatchInfo.eInvoiceCancelDate : true;
    const ewayOk = ewayMade ? !!this.dispatchInfo.ewayCancelDate : true;
    return eInvoiceOk && ewayOk;
  }
  handleQuantityChange(row) {
    // When quantity dispatched changes, update quantity received to match
    this.$set(row, 'quantityReceived', row.quantity);
    this.handleQuantityReceived(row, row.quantity);
  }
  async saveDispatchQuantityChange(row, index) {
    try {
      var _row$tempQuantity;
      const newQuantity = (_row$tempQuantity = row.tempQuantity) !== null && _row$tempQuantity !== void 0 ? _row$tempQuantity : row.quantity;
      const oldQuantity = row.maxQuantity;
      if (newQuantity === oldQuantity) {
        this.$set(row, 'isDisabled', true);
        return;
      }
      const differenceQuantity = oldQuantity - newQuantity;
      const payload = {
        quantity: newQuantity,
        differenceQuantity
      };
      await (0, _ordersProductsDispatches.modifyOrdersProductsDispatch)(row.id, payload);
      // Use $set for reactivity
      this.$set(row, 'quantity', newQuantity);
      this.$set(row, 'tempQuantity', undefined);
      this.$set(row, 'isDisabled', true);
      this.$message({
        type: 'success',
        message: 'Quantity updated successfully.'
      });
    } catch (error) {
      console.error('saveDispatchQuantityChange error:', error);
      this.$message({
        type: 'error',
        message: 'An error occurred while updating the quantity. Please try again.'
      });
    }
  }
  handleDispatchQuantityChange(row, newQuantity) {
    row.tempQuantity = newQuantity;
  }
  // Fired on cross button click or popconfirm cancel — reverts to original
  cancelDispatchQuantityChange(row) {
    if (row.tempQuantity !== undefined) {
      this.$set(row, 'quantity', row.originalQuantity);
      this.$set(row, 'tempQuantity', undefined);
    }
    this.$set(row, 'isDisabled', true);
  }
  async handleQuantityReceived(row, quantityReceived) {
    if (quantityReceived === undefined || quantityReceived === null) {
      quantityReceived = row.quantity;
    }
    this.$set(row, 'quantityReceived', quantityReceived);
    // Check if inventory item already exists and update, otherwise add new
    const existingItem = this.inventoryArray.find(item => item.ordersProductId === row.ordersProduct.id);
    const inventoryItem = {
      id: 0,
      ordersProductId: row.ordersProduct.id,
      ordersDispatchId: this.ordersDispatchId,
      adminId: this.loggedInAdmin.id,
      unitId: this.unitId,
      productId: row.ordersProduct.product.id,
      productsVariationId: row.ordersProduct.productsVariation.id,
      masterCarton: row.ordersProduct.product.masterCarton,
      quantity: row.quantity,
      quantityReceived: quantityReceived,
      cartonQuantity: Math.round(quantityReceived / row.ordersProduct.product.masterCarton),
      looseQuantity: 0,
      currentStock: 0,
      inventoryInwardId: null,
      comments: row.comments || ''
    };
    if (existingItem) {
      Object.assign(existingItem, inventoryItem);
    } else {
      this.inventoryArray.push(inventoryItem);
    }
  }
  async handleCommentsInput(row, comments) {
    this.$set(row, 'comments', comments);
    // Find the corresponding inventory item and update comments
    const inventoryItem = this.inventoryArray.find(item => item.ordersProductId === row.ordersProduct.id);
    if (inventoryItem) {
      inventoryItem.comments = comments;
    }
  }
  async handleApproveTransit() {
    try {
      const confirmBoxMessage = `Approving Will Manipulate The Stocks From the Source ${this.sourceBranchName}(${this.sourceUnitName}) To Destination ${this.destinationBranchName}(${this.destinationUnitName}). Do You Want To Approve The Transit?`;
      await this.$confirm(confirmBoxMessage, {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'No',
        type: 'warning'
      });
      this.formData.status = 'Approved';
      this.formData.invoiceManagerId = this.loggedInAdmin.id;
      this.formData.transitToApprove = true;
      await (0, _ordersDispatches.updateOrdersDispath)(this.formData.id, this.formData);
      this.$message({
        message: 'Transit approved successfully',
        type: 'success'
      });
      // Group inventoryArray by productId + productsVariationId to merge duplicate products
      const groupedInventory = this.inventoryArray.reduce((acc, element) => {
        const key = `${element.productId}_${element.productsVariationId}`;
        if (!acc[key]) {
          acc[key] = {
            ...element,
            unitId: this.destinationUnitId,
            action: 'inward',
            adminId: this.loggedInAdmin.id,
            ordersDispatchId: this.ordersDispatchId,
            quantity: 0,
            quantityReceived: 0
          };
        }
        acc[key].quantity += Number(element.quantity);
        acc[key].quantityReceived += Number(element.quantityReceived);
        return acc;
      }, {});
      const destinationInventoryArray = Object.values(groupedInventory);
      await this.handleInventoryUpdate(destinationInventoryArray);
      // Prepare payload with productsReceived for each grouped row
      const payloadWithProductsReceived = destinationInventoryArray.map(inventoryItem => {
        // Find the corresponding row in list to get productsReceived
        const correspondingRow = this.list.find(row => row.ordersProduct && row.ordersProduct.product.id === inventoryItem.productId);
        // Extract productsReceived array with only productId, variationId, and quantity
        const productsReceived = correspondingRow && correspondingRow.productsReceived ? correspondingRow.productsReceived.map(product => ({
          productId: product.productId,
          variationId: product.variationId,
          quantity: product.quantity
        })) : [];
        return {
          ...inventoryItem,
          productsReceived
        };
      });
      await (0, _ordersDispatches.updateDepoDispatch)(this.ordersDispatchId, payloadWithProductsReceived);
      _router.default.push('/orders-dispatches/list');
    } catch (error) {
      if (error.message !== 'confirm') {
        this.$message({
          type: 'error',
          message: 'An error occurred while approving the transit'
        });
      }
    }
  }
  async handleInventoryUpdate(inventoryArray) {
    if (inventoryArray.length === 0) return;
    try {
      await (0, _inventoryInwardsLogs.manageInventoryInwardsLog)(inventoryArray);
      this.$message({
        message: 'Inventory updated successfully',
        type: 'success'
      });
    } catch (error) {
      this.$message({
        type: 'error',
        message: 'Failed to update inventory. Please try again.'
      });
    }
  }
  validateForm(action = 'Reject') {
    this.$refs.formData.validate(valid => {
      if (valid) {
        switch (action) {
          case 'Request Approval':
            this.sendForApproval();
            break;
          case 'Approve':
            this.approveForm();
            break;
          case 'Reject':
            this.rejectForm();
            break;
          default:
            break;
        }
      } else {
        return false;
      }
    });
  }
  async sendForApproval() {
    try {
      this.formData.status = 'Request Approval';
      await (0, _ordersDispatches.updateOrdersDispath)(this.formData.id, this.formData);
      this.$message({
        type: 'success',
        message: 'Dispatch sent for approval'
      });
      _router.default.push('/orders-dispatches/list');
    } catch (error) {
      this.$message({
        type: 'error',
        message: 'Failed to send dispatch for approval'
      });
    }
  }
  async handleTransit() {
    try {
      await this.$confirm('Do you want to mark this order as In Transit?', 'Confirm Transit', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      });
      this.formData.status = 'In Transit';
      await (0, _ordersDispatches.updateOrdersDispath)(this.formData.id, this.formData);
      this.$message({
        type: 'success',
        message: 'Order marked as In Transit'
      });
      _router.default.push('/orders-dispatches/list');
    } catch (error) {
      if (error.message !== 'confirm') {
        this.$message({
          type: 'error',
          message: 'Failed to update transit status'
        });
      }
    }
  }
  async approveForm() {
    try {
      this.approveDialogFormVisible = false;
      this.formData.status = 'Approved';
      this.formData.invoiceManagerId = this.loggedInAdmin.id;
      if (this.isBranchDispatch && this.isDispatchApproved) {
        this.formData.status = 'In Transit';
      }
      await (0, _ordersDispatches.updateOrdersDispath)(this.formData.id, this.formData);
      this.$message({
        type: 'success',
        message: 'Dispatch approved successfully'
      });
      _router.default.push('/orders-dispatches/list');
    } catch (error) {
      this.$message({
        type: 'error',
        message: 'Failed to approve dispatch'
      });
    }
  }
  async rejectForm() {
    try {
      this.rejectDialogFormVisible = false;
      this.formData.status = 'Rejected';
      this.formData.invoiceManagerId = this.loggedInAdmin.id;
      await (0, _ordersDispatches.updateOrdersDispath)(this.formData.id, this.formData);
      this.$message({
        type: 'success',
        message: 'Dispatch rejected successfully'
      });
      _router.default.push('/orders-dispatches/list');
    } catch (error) {
      this.$message({
        type: 'error',
        message: 'Failed to reject dispatch'
      });
    }
  }
  toggleDisable(index, row) {
    if (row.isDisabled) {
      row.originalQuantity = row.quantity; // snapshot before editing
    }
    row.isDisabled = !row.isDisabled;
  }
  async downloadInvoice(id = 0) {
    try {
      this.loadingForPreview = true;
      const data = await (0, _ordersDispatches.viewInvoice)(id);
      if (data && data.url) {
        window.open(data.url, '_blank');
      } else {
        this.$message({
          message: 'Failed to generate invoice',
          type: 'error'
        });
      }
    } catch (error) {
      this.$message({
        message: 'Error generating invoice. Please try again.',
        type: 'error'
      });
    } finally {
      this.loadingForPreview = false;
    }
  }
  _isSuperAdmin() {
    return (0, _common.isSuperAdmin)();
  }
  _isInvoiceManager() {
    return (0, _common.isInvoiceManager)();
  }
  async saveTermsOfDelivery() {
    try {
      this.dispatchInfo.editingTermsOfDelivery = false;
      const updated = await (0, _ordersDispatches.updateOrdersDispath)(this.dispatchInfo.id, {
        termsOfDelivery: this.dispatchInfo.modifiedTermsOfDelivery
      });
      if (updated) {
        this.dispatchInfo.termsOfDelivery = updated.termsOfDelivery;
        this.dispatchInfo.modifiedTermsOfDelivery = updated.termsOfDelivery;
      }
    } catch (error) {
      this.$message({
        type: 'error',
        message: 'Failed to save terms of delivery'
      });
      this.dispatchInfo.editingTermsOfDelivery = true;
    }
  }
  async saveVehicleNumber() {
    try {
      this.dispatchInfo.editingVehicleNumber = false;
      const updated = await (0, _ordersDispatches.updateOrdersDispath)(this.dispatchInfo.id, {
        vehicleNumber: this.dispatchInfo.modifiedVehicleNumber
      });
      if (updated) {
        this.dispatchInfo.vehicleNumber = updated.vehicleNumber;
        this.dispatchInfo.modifiedVehicleNumber = updated.vehicleNumber;
      }
    } catch (error) {
      this.$message({
        type: 'error',
        message: 'Failed to save vehicle number'
      });
      this.dispatchInfo.editingVehicleNumber = true;
    }
  }
  async getProductList(query) {
    try {
      this.productListLoading = true;
      if (query && query.length >= 2) {
        this.products = await (0, _products.searchProducts)((0, _utils.getQuery)({
          keyword: query
        }));
      } else {
        // Clear products list if query is too short
        this.products = [];
      }
      this.productListLoading = false;
    } catch (err) {
      this.productListLoading = false;
      this.products = [];
    }
  }
  toggleWrongProductDialogVisible(index, row) {
    this.selectedRow = row;
    this.selectedRowIndex = index;
    // Initialize table data with existing products received or start with one empty row
    if (row.productsReceived && row.productsReceived.length > 0) {
      this.wrongProductTableData = row.productsReceived.map(item => ({
        selectedProduct: item.variationId ? `${item.productId}-variation-${item.variationId}-${item.productName}-${item.variationName}` : `${item.productId}-product-${item.productName}`,
        productId: item.productId,
        variationId: item.variationId,
        productName: item.productName,
        variationName: item.variationName,
        quantity: item.quantity
      }));
    } else {
      // Start with one empty row so user can immediately start adding products
      this.wrongProductTableData = [{
        selectedProduct: null,
        productId: null,
        variationId: null,
        productName: null,
        variationName: null,
        quantity: 1
      }];
    }
    // Clear products list - user needs to search
    this.products = [];
    this.wrongProductDialogVisible = true;
  }
  addProductRow() {
    this.wrongProductTableData.push({
      selectedProduct: null,
      productId: null,
      variationId: null,
      productName: null,
      variationName: null,
      quantity: 1
    });
  }
  removeProductRow(index) {
    this.wrongProductTableData.splice(index, 1);
  }
  handleProductChange(index, value) {
    if (!value) {
      this.wrongProductTableData[index].productId = null;
      this.wrongProductTableData[index].variationId = null;
      this.wrongProductTableData[index].productName = null;
      this.wrongProductTableData[index].variationName = null;
      return;
    }
    // Parse the value format: "productId-variation-variationId-productName-variationName" or "productId-product-productName"
    const parts = value.split('-');
    if (parts[1] === 'variation') {
      this.wrongProductTableData[index].productId = parseInt(parts[0]);
      this.wrongProductTableData[index].variationId = parseInt(parts[2]);
      this.wrongProductTableData[index].productName = parts[3];
      this.wrongProductTableData[index].variationName = parts.slice(4).join('-');
    } else if (parts[1] === 'product') {
      this.wrongProductTableData[index].productId = parseInt(parts[0]);
      this.wrongProductTableData[index].variationId = null;
      this.wrongProductTableData[index].productName = parts.slice(2).join('-');
      this.wrongProductTableData[index].variationName = null;
    }
  }
  saveWrongProducts() {
    if (!this.selectedRow) return;
    // Validate that all products have been selected and quantities are valid
    const hasInvalidRows = this.wrongProductTableData.some(row => !row.selectedProduct || !row.quantity || row.quantity <= 0);
    if (hasInvalidRows) {
      this.$message({
        type: 'warning',
        message: 'Please select all products and enter valid quantities'
      });
      return;
    }
    // Save products received to the row
    const productsReceived = this.wrongProductTableData.map(row => ({
      productId: row.productId,
      variationId: row.variationId,
      productName: row.productName,
      variationName: row.variationName,
      quantity: row.quantity
    }));
    this.$set(this.selectedRow, 'productsReceived', productsReceived);
    this.$set(this.list, this.selectedRowIndex, this.selectedRow);
    // Update inventory array if needed
    const inventoryItem = this.inventoryArray.find(item => item.ordersProductId === this.selectedRow.ordersProduct.id);
    if (inventoryItem) {
      inventoryItem.productsReceived = productsReceived;
    }
    this.wrongProductDialogVisible = false;
    this.$message({
      type: 'success',
      message: 'Products received saved successfully'
    });
  }
  async handleEdit() {
    // Pre-fill form with current dispatchInfo values
    this.editForm.dealersTransporterId = this.dispatchInfo.dealersTransporterId;
    this.editForm.ewayBillNo = this.dispatchInfo.ewayBillNo || '';
    this.editForm.dealerSpecialDiscount = this.dispatchInfo.dealerSpecialDiscount || 0;
    this.editForm.tdsAmount = this.dispatchInfo.tdsAmount || 0;
    this.editForm.tcsAmount = this.dispatchInfo.tcsAmount || 0;
    this.editForm.softRecalculate = true;
    // Always await so options are ready before dialog opens
    if (!this.transporterOptions.length) {
      await this.fetchTransporterOptions();
    }
    this.editDialogVisible = true; // open AFTER options are loaded
  }
  async fetchTransporterOptions() {
    try {
      // Replace with your actual API call
      const res = await (0, _dealersTransporters.getDealersTransporters)((0, _utils.getQuery)({
        dealerId: this.dispatchInfo.dealerId,
        enabled: true,
        filter: {
          dealerId: '$eq',
          enabled: 'eq'
        }
      }));
      // Adjust based on your API response shape
      this.transporterOptions = res.map(t => ({
        id: t.id,
        name: t.transporter.name
      }));
    } catch (e) {
      this.$message.error('Failed to load transporters');
    }
  }
  handleEditDialogClose(done) {
    done();
  }
  handleEditCancel() {
    this.editDialogVisible = false;
  }
  async handleEditSave() {
    this.editSaving = true;
    try {
      const selectedTransporter = this.transporterOptions.find(t => t.id === this.editForm.dealersTransporterId);
      await (0, _ordersDispatches.updateOrdersDispath)(this.dispatchInfo.id, {
        dealersTransporterId: this.editForm.dealersTransporterId,
        dealersTransporter: {
          id: selectedTransporter.id
        },
        ewayBillNo: this.editForm.ewayBillNo,
        dealerSpecialDiscount: this.editForm.dealerSpecialDiscount,
        tdsAmount: this.editForm.tdsAmount,
        tcsAmount: this.editForm.tcsAmount,
        softRecalculate: this.editForm.softRecalculate
      });
      this.$message.success('Dispatch updated successfully');
      this.editDialogVisible = false;
      // // Re-render the page
      // this.$router.go(0);
    } catch (e) {
      this.$message.error('Failed to update dispatch');
    } finally {
      this.editSaving = false;
    }
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'DispatchInfo',
  components: {
    Inr: _index.default
  }
})], default_1);
var _default = exports.default = default_1;